import { CardEnum, TurnState } from '@colonist/game-states';
import { ArrayUtils } from '@colonist/utils';
import { CardClickPopupType, CardDataController } from '@colonist/game-card-types';
import { ActionsThatCanBeCancelled } from '@colonist/game-base-types';
export const getCardsToGreyForBankTrade = (myBankTradeRatioState, cardState)=>{
    const cardsToGrey = [];
    for (const [cardEnum, requiredRatio] of Object.entries(myBankTradeRatioState)){
        var _cardState_cardEnum;
        const cardCount = (_cardState_cardEnum = cardState[cardEnum]) !== null && _cardState_cardEnum !== void 0 ? _cardState_cardEnum : 0;
        if (cardCount < requiredRatio) {
            for(let i = 0; i < cardCount; i++){
                cardsToGrey.push(Number(cardEnum));
            }
        }
    }
    return cardsToGrey;
};
const isValidTurnState = (cardData, currentState)=>{
    if (cardData.allowableTurnStates == undefined) return true;
    if (cardData.allowableTurnStates.includes(currentState.turnState)) return true;
    return false;
};
export const canClickCard = ({ cardEnum, currentState, isReplay, myColor, translationKeyContext, isShowTradePanel, isActionBoxPickCardOpening, currentStateValidator })=>{
    const cardData = CardDataController.getCardDataForCard(cardEnum);
    if (!cardData) {
        return {
            canClickCard: false,
            helperText: undefined
        };
    }
    if (isReplay) {
        return {
            canClickCard: false,
            helperText: {
                key: 'strings:game.errors.replayMode'
            }
        };
    }
    if (isActionBoxPickCardOpening) {
        return {
            canClickCard: true,
            helperText: undefined
        };
    }
    if (isShowTradePanel) {
        if (cardData.clickPopupType == CardClickPopupType.TradeWindow || cardData.cardEnum == CardEnum.AnyResource) {
            return {
                canClickCard: true,
                helperText: undefined
            };
        }
        return {
            canClickCard: false,
            helperText: {
                key: 'strings:game.tooltips.cannotTradeDevCard',
                options: {
                    context: translationKeyContext
                }
            }
        };
    }
    if (!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, currentStateValidator.getPlayerActionState(myColor))) {
        return {
            canClickCard: false,
            helperText: {
                key: 'strings:game.errors.finishCurrentAction'
            }
        };
    }
    const isVictoryPointDevelopmentCard = cardEnum == CardEnum.VictoryPoint;
    if (isVictoryPointDevelopmentCard) {
        return {
            canClickCard: true,
            helperText: undefined
        };
    }
    const isNotMyTurn = !currentStateValidator.currentTurnPlayers.includes(myColor);
    if (isNotMyTurn) {
        const isDevOrProgressCard = CardDataController.isDevelopmentOrProgressCard(cardEnum);
        return {
            canClickCard: false,
            helperText: isDevOrProgressCard ? undefined : {
                key: 'strings:game.errors.notYourTurn'
            },
            blockedReason: 'notYourTurn'
        };
    }
    const isInSpecialBuildPhase = currentState.turnState == TurnState.SpecialBuildPhase;
    if (isInSpecialBuildPhase) {
        const doesClickingCardTriggerTrade = cardData.clickPopupType == CardClickPopupType.TradeWindow;
        const devCardsDisabledErrorMessage = {
            key: 'strings:game.errors.developmentCardsDisabled',
            options: {
                context: translationKeyContext
            }
        };
        const errorMessage = doesClickingCardTriggerTrade ? {
            key: 'strings:game.errors.tradingDisabled'
        } : devCardsDisabledErrorMessage;
        return {
            canClickCard: false,
            helperText: errorMessage
        };
    }
    if (!isValidTurnState(cardData, currentState)) {
        const isCardAchemist = cardEnum == CardEnum.ProgressCardScienceAlchemist;
        const errorMessage = isCardAchemist ? {
            key: 'strings:game.errors.canOnlyBePlayedBeforeRollingDice'
        } : {
            key: 'strings:game.errors.finishCurrentAction'
        };
        return {
            canClickCard: false,
            helperText: errorMessage
        };
    }
    return {
        canClickCard: true,
        helperText: undefined
    };
};
export const getCanClickCardDataForAllCards = ({ allMyCards, currentState, isReplay, myColor, translationKeyContext, isShowTradePanel, isActionBoxPickCardOpening, currentStateValidator })=>{
    const cardsHelperTextLocal = {};
    const myUniqueAllCards = ArrayUtils.getUniqueElements(allMyCards);
    for (const cardEnum of myUniqueAllCards){
        const canClickCardData = canClickCard({
            cardEnum: cardEnum,
            currentState: currentState,
            isReplay: isReplay,
            myColor: myColor,
            translationKeyContext: translationKeyContext,
            isShowTradePanel: isShowTradePanel,
            isActionBoxPickCardOpening: isActionBoxPickCardOpening,
            currentStateValidator: currentStateValidator
        });
        cardsHelperTextLocal[cardEnum] = canClickCardData;
    }
    return cardsHelperTextLocal;
};
export const removeCardsSelected = (resourceCards, selectedResourceCards)=>{
    if (selectedResourceCards != null) {
        const myCards = [
            ...resourceCards
        ];
        ArrayUtils.removeElementsFromArray(myCards, selectedResourceCards);
        return myCards;
    }
    return resourceCards;
};
